<template>
  <div class="promotionPriority-page flex">
    <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="权益主标题" prop="titles">
          <div v-if="isEdit" class="mainTitleWrap flex">
            <template v-for="(mainTitle,titleN) in form.titles">
              <el-input :key="titleN+'mainTitle'" v-model="form.titles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案' : '请输入第二行主标题文案' " />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(mainTitle,titleN) in form.titles" :key="titleN+'mainTitle'">{{ mainTitle }}</div>
          </div>
        </el-form-item>
        <el-form-item label="副标题" prop="subtitles">
          <div v-if="isEdit" class="subTitleWrap flex">
            <template v-for="(subTitle,titleN) in form.subtitles">
              <el-input :key="titleN+'subTitle'" v-model="form.subtitles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行副标题文案' : '请输入第二行副标题文案'" />
            </template>
          </div>
          <div v-else class="lh-20" style="padding-top: 5px;">
            <div v-for="(subTitle,titleN) in form.subtitles" :key="titleN+'subTitle'">{{ subTitle }}</div>
          </div>
        </el-form-item>
        <el-form-item label="促销时间" prop="startTime" style="width: 279px">
          <el-date-picker v-model="form.startTime" type="datetime" placeholder="促销开始时间" prefix-icon="el-icon-date" class="custom-date" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :disabled="!isEdit" />
        </el-form-item>
        <el-form-item label="背景图" prop="imageUrl" class="image-config">
          <div class="flex uploadImg-cont">
            <UploadImage v-if="isEdit" :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath" @upload="uploader" @triggerReg="handleCheckReg" />
            <img v-else class="read-img" :src="form.imageUrl" alt="">
          </div>
        </el-form-item>
        <el-form-item label="活动渠道" prop="activityType">
          <template v-if="isEdit">
            <el-radio-group v-model="form.activityType">
              <el-radio :label="1">线上</el-radio>
              <el-radio :label="2">线下</el-radio>
              <el-radio :label="3">线上+线下</el-radio>
            </el-radio-group>
          </template>
          <div v-else>{{ form.activityType === 1 ? '线上' : form.activityType === 2 ? '线下' :form.activityType === 3 ? '线上+线下' : '' }}</div>
        </el-form-item>
        <el-form-item v-if="form.activityType === 1 || form.activityType === 3" label="线上购买链接" prop="linked">
          <template v-if="isEdit">
            <el-input v-model="form.linked" class="common-input w-360" placeholder="请输入EC购买链接地址" />
          </template>
          <div v-else>{{ form.linked }}</div>
        </el-form-item>
        <el-form-item label="门店特卖会地址" prop="storeSaleEventAddressVOS">
          <div>
            <el-table ref="storeTable" size="small" :data="form.storeSaleEventAddressVOS" style="width: 100%;">
              <el-table-column prop="cityName" label="城市" />
              <el-table-column prop="storeName" label="门店名称" />
              <el-table-column prop="storeAddress" label="门店地址" />
              <el-table-column prop="eventStartTime" label="活动时间">
                <template v-slot="{row}">
                  <span> {{ $moment(row.eventStartTime).format('MM月DD') }}</span>
                  <span style="margin-left: 3px; margin-right: 3px;">-</span>
                  <span> {{ $moment(row.eventEndTime).format('MM月DD日') }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="isEdit" label="操作">
                <template v-slot="{ $index,row }">
                  <el-button size="small" type="text" class="link-color" @click="removeStore($index,row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-if="isEdit" class="add-store-wrap flex" style="width: 100%; margin-top: 30px;">
              <div style="width: 7.67%; margin-right: 30px;">
                <el-input v-model="addStore.cityName" placeholder="输入城市" />
              </div>
              <div style="width: 28.57%; margin-right: 30px;">
                <el-input v-model="addStore.storeName" placeholder="门店名称" />
              </div>
              <div style="width: 28.57%; margin-right: 30px;">
                <el-input v-model="addStore.storeAddress" placeholder="门店地址" />
              </div>
              <div style="width: 17.97%; margin-right: 30px;">
                <el-date-picker v-model="eventTimes" type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" prefix-icon="el-icon-date" style="width: 100%;" format="dd日 HH:mm" value-format="yyyy-MM-dd HH:mm:ss" @change="changeEventTimes" />
              </div>
              <div style="width: 8.85%;">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add">添加</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="opetare-box flex">
          <div class="flex btns">
            <template v-if="isEdit">
              <el-button type="info" @click="cancel">取消</el-button>
              <el-button type="primary" @click="submit">保存</el-button>
            </template>
            <el-button v-else type="primary" @click="cancel">返回</el-button>

          </div>
        </el-form-item>
      </div>

    </el-form>

  </div>
</template>

<script>
import { PromotionPriority } from '@/model/Benefits';
import UploadImage from '@/components/UploadImage';
export default {
  components: { UploadImage },
  data() {
    return {
      form: new PromotionPriority(),
      rules: {
        titles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入权益主标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入权益主标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        subtitles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入副标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入副标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        startTime: { required: true, message: "请选择促销开始时间", trigger: ["blur", "change"] },
        imageUrl: {
          required: true, validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(`请上传背景图`));
            }
            callback();
          }, trigger: ['change'],
        },
        activityType: { required: true, message: "请选择活动渠道", trigger: ["blur", "change"] },
        linked: { required: true, message: "请输入EC购买链接地址", trigger: ["blur", "change"] },
        storeSaleEventAddressVOS: {
          required: true, validator: (rule, value, callback) => {
            if (!value || !value.length) {
              callback(new Error(`请添加门店特卖会地址`));
            }
            callback();
          }, trigger: ['blur'],
        },

      },
      addStore: {
        cityName: '',
        storeName: '',
        storeAddress: '',
        eventStartTime: '',
        eventEndTime: '',
        longitude: 0,
        latitude: 0,

      },
      eventTimes: [],
      deleteId: [],
      isEdit: true,
      savePath: 'member/PromotionPriority/',
    };
  },
  created() {
    const { query } = this.$route;
    if (query.id) {
      this.id = +query.id;
      this.fetchData();
    }
    if (query.readOnly) {
      this.isEdit = query.readOnly !== '1';
    }
  },
  methods: {
    fetchData() {
      const obj = {
        type: 5,
        promotionPriority: {},
        id: this.id,
      };
      this.$Api.benefits.query(obj).then(res => {
        if (res?.promotionPriority?.length) {
          const data = res.promotionPriority.find(item => item.id === this.id);
          if (!data) return;
          this.form = new PromotionPriority(data);
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },
    removeStore(i, row) {
      if (row.id) {
        this.deleteId.push(row.id);
      }
      this.form.storeSaleEventAddressVOS.splice(i, 1);
    },
    changeEventTimes(e) {
      if (e?.length === 2) {
        this.addStore.eventStartTime = e[0];
        this.addStore.eventEndTime = e[1];
      } else {
        this.addStore.eventStartTime = "";
        this.addStore.eventEndTime = "";
      }
      console.log(e);
    },
    add() {
      const errMap = {
        'cityName': '请填写城市名称',
        'storeName': '请填写门店名称',
        'storeAddress': '请填写门店地址',
        'eventStartTime': '请选择活动时间',
        'eventEndTime': '请选择活动时间',
      };
      for (const key in this.addStore) {
        if (this.addStore[key] === '') {
          return this.$message.warning(errMap[key] || '添加失败');
        }
      }
      const data = { ...this.addStore };
      if (this.form.id) {
        data.loyaltyExclusiveBenefitsId = this.form.id;
      }
      this.form.storeSaleEventAddressVOS.push(data);
      this.addStore = {
        cityName: '',
        storeName: '',
        storeAddress: '',
        eventStartTime: '',
        eventEndTime: '',
        longitude: 0,
        latitude: 0,
      };
      this.eventTimes = [];
      this.$refs.form?.clearValidate('storeSaleEventAddressVOS');
    },
    cancel() {
      this.$router.push({ path: '/member/promotionPriority/index' });
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const str = this.form.id ? '编辑成功' : '新增成功';
          const api = this.form.id ? this.$Api.benefits.update : this.$Api.benefits.add;
          const obj = {
            type: 5,
            promotionPriority: {},
          };
          if (this.form.id) {
            obj.promotionPriority = {
              ...this.form,
            };
            this.$Api.benefits.updateStore({
              deleteId: this.deleteId,
              storeSaleEventAddressDTOS: this.form.storeSaleEventAddressVOS,
            }).then(res => {
              console.log(res);
            }).finally(() => {
              api(obj).then(res => {
                this.$message.success(str);
                this.cancel();
              });
            });
          } else {
            const { storeSaleEventAddressVOS, ...newObject } = this.form;
            obj.promotionPriority = {
              ...newObject,
              storeSaleEventAddressDTOS: storeSaleEventAddressVOS,
            };
            api(obj).then(res => {
              this.$message.success(str);
              this.cancel();
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.promotionPriority-page {
  position: relative;

  min-height: calc(100vh - 178px);
  .mt-30 {
    margin-top: 30px;
  }
  .w-360 {
    width: 360px !important;
  }
  .lh-20 {
    line-height: 20px;
  }
  :deep(.custom-date) {
    width: 172px !important;
  }
  :deep(.el-input.is-disabled) {
    .el-input__icon {
      cursor: unset;
    }
    .el-input__inner {
      cursor: unset;

      color: #494949;
      border-color: #fff;
      background: #fff;
    }
  }
  :deep(.common-input) {
    width: 360px;
    height: 32px !important;
    margin-right: 30px;

    background: #f7f7f7;

    line-height: 32px !important;
    input {
      height: 32px !important;

      line-height: 32px !important;
    }
    :deep(.el-input__inner) {
      &::placeholder {
        color: #bbbbbb;
      }
    }
    &.underline {
      .el-input__inner {
        text-decoration: underline;
      }
    }
    .el-input__inner {
      color: #494949;
    }
  }
  .my-form {
    display: flex;
    flex: 1;
    flex-direction: column;
    .read-img {
      width: 210px;
      height: 150px;

      border: 1px dashed #e3e3e5;
      border-radius: 16px;
    }
  }
  .opetare-box {
    justify-content: center;

    margin-top: 30px;
    margin-bottom: 0 !important;
  }
}
</style>
